import type React from "react";
import styles from "./SkeletonBlock.module.scss";

type SkeletonBlockProps = {
    width?: number | string;
    height?: number | string;
    style?: React.CSSProperties;
};

export const SkeletonBlock = ({ width = "100%", height = "100%", style }: SkeletonBlockProps) => (
    <div
        className={styles.skeleton}
        style={{
            width,
            height,
            ...style,
        }}
    />
);
